export default defineNuxtRouteMiddleware(async (to, from) => {
   const { getAuthed, user } = useAuthStore();
   const { logInfo } = useDebugger();

   logInfo("SCHOOL HOMEPAGE - AUTHED", getAuthed);

   if (getAuthed) {
      const school = user?.school?.slug;

      if (to.path === "/" || to.path == "/home" || to.path == "/home/") {
         return navigateTo(`/home/${school}`);
      }

      if (school !== to.params.school && to.name == "school-homepage") {
         return navigateTo(`/home/${school}`);
      }
      return;
   } else {
      if (
         to.name === "school-homepage" ||
         to.path == "/home" ||
         to.path == "/home/"
      ) {
         return navigateTo(`/`);
      }
   }
   // }
});
